export default {"src":"/_next/static/media/powerUnknownIcon.e63fe194.svg","height":27,"width":25,"blurWidth":0,"blurHeight":0};